import bulmaCalendar from "bulma-calendar";

export function initDatepickers(){
    const date = new Date();
    let day= String(date.getDate()).padStart(2,"0");
    let month= String(date.getMonth()+1).padStart(2,"0");
    let year= date.getFullYear();
    const calendars = bulmaCalendar.attach('[type="date"]',{
        isRange: true,
        dateFormat: "dd.MM.yyyy",
        showFooter: false,
        lang: "de",
        minDate: date,
        allowSameDayRange: false
    });
}